import {View} from 'react-native';
import React from 'react';

import {Props} from './model';
import {withActiveForm} from '../activeFormContext';

const KeyboardHandleWrappler: React.FC<Props> = (props: Props) => {
  return <View {...props} />;
};

export default withActiveForm(KeyboardHandleWrappler);
